import { Link } from '@mui/material';

import { RouterLink } from 'src/routes/components';

// `[label](url)` markdown-style link. Label is anything but `]`; href has no whitespace or `)`.
const MD_LINK_SOURCE = '\\[([^\\]]+)\\]\\(([^)\\s]+)\\)';
// Bare http(s) URL; strips trailing punctuation that isn't URL-safe.
const URL_SOURCE = 'https?:\\/\\/[^\\s<>"\'`]+[^\\s<>"\'`.,;:!?)\\]}]';
// Combined: markdown link tried first per leftmost-alternative semantics.
const COMBINED_REGEX = new RegExp(`${MD_LINK_SOURCE}|${URL_SOURCE}`, 'g');

function renderLink(key, label, href, onClick) {
  const isInternal = href.startsWith(window.location.origin) || href.startsWith('/');
  if (isInternal) {
    const pathname = href.startsWith('/')
      ? href
      : href.slice(window.location.origin.length) || '/';
    return (
      <Link
        key={key}
        component={RouterLink}
        href={pathname}
        underline="hover"
        onClick={onClick}
      >
        {label}
      </Link>
    );
  }
  return (
    <Link
      key={key}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      onClick={onClick}
    >
      {label}
    </Link>
  );
}

export function renderMessageWithLinks(message, { onLinkClick } = {}) {
  if (!message) return null;
  const segments = [];
  let cursor = 0;
  Array.from(message.matchAll(COMBINED_REGEX)).forEach((match) => {
    const [full, mdLabel, mdHref] = match;
    const start = match.index;
    if (start > cursor) {
      segments.push(<span key={`t-${cursor}`}>{message.slice(cursor, start)}</span>);
    }
    if (mdLabel && mdHref) {
      segments.push(renderLink(`l-${start}`, mdLabel, mdHref, onLinkClick));
    } else {
      segments.push(renderLink(`l-${start}`, full, full, onLinkClick));
    }
    cursor = start + full.length;
  });
  if (cursor < message.length) {
    segments.push(<span key={`t-${cursor}`}>{message.slice(cursor)}</span>);
  }
  return segments;
}
